<template>
  <div class="badge-page">     
    <b-container>      
      <Widget class="mx-auto" customHeader v-if="user">
        <h4 class="text-muted mb-1 mt-0 text-center">
          Skor ToSM A1
        </h4>
        <div v-if="!userLoaded" class="text-center">
          <b-spinner variant="warning" type="grow" label="Spinning"></b-spinner>
        </div>
        <div v-if="userLoaded" class="mb-3">
          <h3 class="mt text-center">{{user.alias}}</h3>
          <p class="text-muted mb-0 mt fs-sm text-center">
            {{user.prov}}<br/>
            {{user.kab}}<br/>
            {{user.org}}<br/>
          </p>
        </div>        
        <b-row  align-v="center" v-bind:key="index" v-for="(ops,index) in dataOps">
          <div v-if="!validOps[index]" class="ops container text-center">
            <b-spinner variant="warning" type="grow" label="Spinning"></b-spinner>
          </div>
          <div v-if="dataOps[index]" class="ops container">
            <b-row>
            <b-col md=4 xs=2 m-0>
            <div :class="kelasKetuntasan(dataOps[index].opm,'text-center p-2 mb-2 align-middle ')" >
              {{operasi[index]}}
              <h4 class="fw-semi-bold mb-0"  >{{dataOps[index].opm.toFixed(2)}}</h4>
              OPM
            </div>
          </b-col>
          <b-col md=8 xs=10>
            <h6 class="fw-semi-bold"  >{{ketuntasan(dataOps[index].opm)}}</h6>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="100-100*dataOps[index].rank/dataOps[index].total"></b-progress>
            Peringkat <strong>ke-{{dataOps[index].rank}}</strong> dari <strong>{{dataOps[index].total}}</strong><br/>
            Lebih baik dari <strong>{{(100-100*dataOps[index].rank/dataOps[index].total).toFixed(2)}}%</strong> pengguna            
          </b-col>
          </b-row>
          </div>
        </b-row>
        <b-row class="text-center mt-2 social" v-if="user">
          <b-col class="text-center">
            <p class="text-center">
              Sebarkan halaman ini
            </p>
            <social-sharing
              :v-if="user!=null"              
              inline-template
              :url="'https://tosm.matematikadetik.com/badgea1/'+uid"
              :title="'Skor ToSM A1 '+ user.alias"
              :description="'Lihat skor dan peringkat ToSM (Test of Second Mathematics) Level A1 dari ' + user.alias "
            >
              <div class="text-center">
                <network network="facebook">
                  <img src="https://img.icons8.com/color/48/000000/facebook-new.png" width="36" class="mr-1">
                </network>
                <network network="twitter">
                  <img src="https://img.icons8.com/color/48/000000/twitter.png" width="36" class="mr-1">                  
                </network>
                <network network="whatsapp">
                  <img src="https://img.icons8.com/color/48/000000/whatsapp.png" width="36" class="mr-1">
                </network>       
                <network network="telegram">
                  <img src="https://img.icons8.com/color/48/000000/telegram-app.png" width="36" class="mr-1">           
                </network>
                
              </div>
            </social-sharing>
          </b-col>
        </b-row>
        <b-row>          
          <b-col class="text-center">
            Install ToSM Digital (Android)<br/>
            <a 
            href='https://play.google.com/store/apps/details?id=com.matematikadetik.tosm&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
            target="_blank"
            >
              <img alt='Temukan di Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/id_badge_web_generic.png' width=175/>
            </a>
          </b-col>
        </b-row>
      </Widget>
      <div class="text-center mb-2">
        2019 &copy; <router-link to="/app/overview"> Matematika Detik </router-link>
      </div>      
    </b-container>
    
      
         
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import axios from '../../../node_modules/axios'
import SocialSharing from 'vue-social-sharing'
import API from '../../config/api'
import SkalaA1 from './SkalaA1'
import UserProfile from './Profile'

export default {
  name: 'BadgeUserPage',
  components: { Widget,SkalaA1,UserProfile,SocialSharing },
  data() {
    return {
      uid : '',
      validUID: false,
      validOps: [false,false,false,false],
      dataOps : [false,false,false,false],
      dataOpsLoaded : [false,false,false,false],
      operasi: ['Tambah (+)','Kurang (-)','Kali (x)','Bagi (\u00f7)'],      
      user: null,
      userLoading: false,
      userLoaded: false,      
      errors: [],
    }
  },
  methods: {    
    ketuntasan(opm) {
      if (opm>=70) {
        return "ISTIMEWA \u2605 \u2605"
      }
      else if (opm>=60) {
        return "ISTIMEWA \u2605"
      }
      else if (opm>=30) {
        return "TUNTAS"
      }
      return "GAGAP HITUNG"
    },
    kelasKetuntasan(opm, cl) {
      // let cl = 'text-center p-2 mb-2 align-middle '
      if (opm < 10 ) {
        cl += 'opmhitam'
      } 
      else if (opm < 20 ) {
        cl += 'opmmerah'
      } 
      else if (opm < 30 ) {
        cl += 'opmkuning'
      }
      else if (opm < 40 ) {
        cl += 'opmhijau'
      }
      else if (opm < 50 ) {
        cl += 'opmbiru'
      }
      else if (opm < 60 ) {
        cl += 'opmungu'
      }
      else {
        cl += 'opmputih'
      }
      return cl
    },
    loadProfile() {
      if (this.uid == null || this.uid == undefined || this.uid === '') {
        return
      } 
      this.userLoading = true
      let uri = API.baseURI+'user/profile/'+this.uid
      // console.log('uri',uri)
      axios.get(uri)
        .then(
          response => {             
            this.user = response.data.user            
            this.userLoading = false
            this.userLoaded = true
            //console.log(this.user)            
          }
        )
        .catch(error => {
          //console.log(error)
          this.errors.push(error)
          this.loading = false
        })      
    },
    loadData() {
      // console.log('load ops data')      
      if (this.uid ==='' || this.uid ==='0' || this.uid == 0) {
        return
      } else {
        this.loadProfile()
        this.loadRankA1()
      }
    },
    loadRankA1() {
      let ops = ['tambah','kurang','kali','bagi']
      for (let i=0; i<ops.length; i++) {
        let o = ops[i]
        axios.get(API.baseURI+'test/urank/A1/'+o+'/'+this.uid)
        .then(
          response => {
            this.validOps.splice(i,1,true)
            if ('rank' in response.data) {
              // console.log(i,'loaded')
              this.dataOps.splice(i,1,response.data) 
              this.validUID = true 
              this.$cookie.set('uid', this.uid, 1);
              // console.log('dataops',this.dataOps)
            } 
            //console.log('TAMBAH',response.data)
          }
        )
        .catch(error => {
          this.errors.push(error)
          // console.log(error)
          this.totalUser = 'Gagal mengambil data'
        })
      }       
    },
  },
  mounted () {
    if (this.$route.params.uid != 0 && this.$route.params.uid !=='' ) {
      //console.log('use param')
      this.uid = this.$route.params.uid
      this.$cookie.set('uid', this.uid, 1);
    } else {
      //console.log('use cookie')
      this.uid = this.$cookie.get('uid');
    }    
    this.loadData()
  },
  created () {    
  },
};

</script>
<style src="./Badge.scss" lang="scss" scoped />